document.addEventListener('DOMContentLoaded', () => {

    let lax = document.querySelector('.verysimple-parallax');
    if(lax != null && lax != undefined){
        let url = lax.getAttribute('data-src');
        lax.style.backgroundImage = "url('"+url+"')";
    }
})

